import { bindSwiperAutoplayToViewport } from "../utils/bind-swiper-autoplay-to-viewport.js";

export function initSpeakerSlider() {
  if (typeof Swiper === "undefined") {
    return;
  }

  const sectionNodes = document.querySelectorAll(".js-speaker-slider");
  if (!sectionNodes.length) {
    return;
  }

  const mobileQuery = window.matchMedia("(max-width: 768px)");

  const controllers = Array.from(sectionNodes).map((sectionEl) => {
    const sliderEl = sectionEl.querySelector(".speaker-list .swiper");
    const btnPrev = sectionEl.querySelector(".speaker_swiper-nav__prev");
    const btnNext = sectionEl.querySelector(".speaker_swiper-nav__next");

    let swiperInstance = null;
    let releaseViewport = () => {};

    const initSwiper = () => {
      if (!sliderEl || swiperInstance) {
        return;
      }

      const slideCountForLoop = sliderEl.querySelectorAll(".swiper-slide").length;
      const useLoop = slideCountForLoop > 2;

      swiperInstance = new Swiper(sliderEl, {
        // < 480px
        slidesPerView: 1,
        spaceBetween: 10,

        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        navigation: {
          prevEl: btnPrev,
          nextEl: btnNext,
        },
        loop: useLoop,
        breakpoints: {
          // 480px–768px (slider only mounts in this range)
          480: {
            slidesPerView: 2,
            spaceBetween: 16,
          },
        },
      });

      releaseViewport();
      releaseViewport = bindSwiperAutoplayToViewport(swiperInstance);
    };

    const destroySwiper = () => {
      if (!swiperInstance) {
        return;
      }
      releaseViewport();
      releaseViewport = () => {};
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    };

    return { initSwiper, destroySwiper };
  });

  const syncViewports = () => {
    controllers.forEach((c) => {
      if (mobileQuery.matches) {
        c.initSwiper();
      } else {
        c.destroySwiper();
      }
    });
  };

  syncViewports();

  if (typeof mobileQuery.addEventListener === "function") {
    mobileQuery.addEventListener("change", syncViewports);
  } else {
    mobileQuery.addListener(syncViewports);
  }
}
